










import { Component, Prop, Vue } from "vue-property-decorator";
import { CrudService } from "../../core/services/crudService";
import { Settings } from "../../core/services/configService";
import { CustomerHelper } from "../../crm/helpers/customerHelper";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import ProgramPanel from "./ProgramPanel.vue";
import CzPlanRow from "../cz/CzPlanRow.vue";
import CzLink from "../cz/CzLink.vue";

@Component({
  components: { ProgramPanel, CzPlanRow, CzLink },
})
export default class ProgramReports extends Vue {
  @Prop({ type: Array, default: () => [] }) reports!: any[];
  @Prop({ type: String, default: "" }) title!: string;

  sentOn(report: any): string {
    return this.$t("Sent on {0}").toString().replace("{0}", ProgramPackTexts.date(report.date));
  }

  async download(report: any) {
    const url = `${Settings.HostName}/api/publicreports/customer/${CustomerHelper.getStoredCustomer()}/${report.id}/download`;
    const blob = await new CrudService().httpGetBlob(url);
    if (blob === null) {
      return;
    }
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${report.title}.pdf`;
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  }
}
